import React, { useState } from "react";
import { FlatList, View, TouchableOpacity, Modal, Alert } from "react-native";
import {
  ContentList,
  ContainerPlaylist,
  Content,
  Avatar,
  ViewButton,
  ContentIcon,
  ContentIconAdmin,
  ContentImage,
  ViewCommentNotification,
} from "../style";

import useViewport from "../../../hooks/useViewport";
import ListHeader from "../../../components/ListHeader";
import THEME from "../../../config/theme";
import { StandardText, SmallText, FooterText } from "../../../config/theme/globalStyles";

import { Provider } from "react-native-paper";
import { MaterialIcons, Feather, MaterialCommunityIcons } from "@expo/vector-icons";
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { copyPage } from "../../../utils/firebaseContentActions";
import { getDocs, collection } from 'firebase/firestore';
import { firestore } from "../../../services/firebase";

const FlatListView = (props) => {
  const {
    cardId,
    categoryId,
    videos,
    selectedId,
    onAddVideoClick,
    cardInformation,
    onEditVideoClick,
    onDeleteVideoClick,
    onEditCardInformationClick,
    onEditOrderClick,
    onDeleteCardClick,
    onEditVideoBackgroundClick,
    onVideoListClick,
    user,
  } = props;

  const { width } = useViewport();
  const breakpoint = 1080;
  const smallScreen = width < breakpoint;
  const newVideoButtonSize = smallScreen ? 24 : 28;
  const addAPhotoSize = smallScreen ? 30 : 40;

  const { customColor, customFont, customInfo } = useCustomTheme();

  const planType = customInfo?.planType;
  const videoHosting = customInfo?.videoHosting;

  // Estados para a funcionalidade "Copiar Página"
  const [showPageModal, setShowPageModal] = useState(false);
  const [modulesForPage, setModulesForPage] = useState([]);
  const [videoToCopy, setVideoToCopy] = useState(null);
  const [destCategoryId, setDestCategoryId] = useState(categoryId);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [showCategorySelection, setShowCategorySelection] = useState(false);

  // Handler para copiar a página: recebe o item (vídeo) e abre o modal
  // const handleCopyPagePress = async (videoItem) => {
  //   try {
  //     setVideoToCopy(videoItem);
  //     // Por padrão, inicie com a categoria atual
  //     setDestCategoryId(categoryId);
  //     await fetchModulesForPage(categoryId);
  //     setShowPageModal(true);
  //   } catch (error) {
  //     console.error("Erro ao buscar módulos para copiar a página:", error);
  //     Alert.alert("Erro", "Não foi possível buscar os módulos para copiar a página.");
  //   }
  // };

  // Busca os módulos disponíveis na categoria informada (exceto o módulo de origem)
  const fetchModulesForPage = async (catId) => {
    try {
      const modulesSnapshot = await getDocs(collection(firestore, 'categories', catId, 'cards'));
      const modulesList = [];
      modulesSnapshot.forEach((docSnap) => {
        if (docSnap.id !== cardId) {
          modulesList.push({ id: docSnap.id, title: docSnap.data().title });
        }
      });
      setModulesForPage(modulesList);
    } catch (error) {
      console.error("Erro ao buscar módulos:", error);
    }
  };
  
  // Ao selecionar um módulo de destino, copia a página para o módulo selecionado
  const handleModuleSelectForPage = async (destinationModuleId) => {
    try {
      console.log("destCategoryId", destCategoryId)
      console.log("cardId", cardId)
      console.log("cardId", videoToCopy.docId)
      console.log("cardId", destCategoryId)
      console.log("cardId", destinationModuleId)

      await copyPage(categoryId, cardId, videoToCopy.docId, destCategoryId, destinationModuleId);
      Alert.alert("Sucesso", "Página copiada com sucesso para o módulo selecionado!");
      setShowPageModal(false);
      setShowCategorySelection(false);
    } catch (error) {
      Alert.alert("Erro", "Erro ao copiar página: " + error.message);
    }
  };

  // Handler para selecionar uma categoria destino
  const handleSelectCategory = async (selectedCatId) => {
    console.log("categoria selecionada". selectedCatId)
    setDestCategoryId(selectedCatId);
    setShowCategorySelection(false);
    await fetchModulesForPage(selectedCatId);
  };

  const content = (
    <>
      <ViewButton>
        {planType === 'premium' && videoHosting === 'ownPanda' &&
          <ContentIconAdmin onPress={() => onAddVideoClick('livestream')}>
            <MaterialIcons
              name="my-library-add"
              size={newVideoButtonSize}
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TEXT_MAIN
              }
            />
            <SmallText
              padding="0.5rem"
              fontSize={
                customFont && customFont.fontSM
                  ? customFont.fontSM
                  : THEME.FONTSIZE.SMALL
              }
              style={{
                fontFamily:
                  customFont && customFont.fontFamilyText
                    ? customFont.fontFamilyText
                    : THEME.FONTFAMILY.REGULAR,
              }}
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TEXT_MAIN
              }>
              NOVA LIVESTREAM
            </SmallText>
          </ContentIconAdmin>
        }
        <ContentIconAdmin onPress={() => onAddVideoClick('live')}>
          <MaterialIcons
            name="my-library-add"
            size={newVideoButtonSize}
            color={
              customColor && customColor.text && customColor.text.app
                ? customColor.text.app
                : THEME.COLORS.TEXT_MAIN
            }
          />
          <SmallText
            padding="0.5rem"
            fontSize={
              customFont && customFont.fontSM
                ? customFont.fontSM
                : THEME.FONTSIZE.SMALL
            }
            style={{
              fontFamily:
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR,
            }}
            color={
              customColor && customColor.text && customColor.text.app
                ? customColor.text.app
                : THEME.COLORS.TEXT_MAIN
            }>
            NOVA AULA AO VIVO
          </SmallText>
        </ContentIconAdmin>
        <ContentIconAdmin onPress={() => onAddVideoClick('content')}>
          <MaterialIcons
            name="my-library-add"
            size={newVideoButtonSize}
            color={
              customColor && customColor.text && customColor.text.app
                ? customColor.text.app
                : THEME.COLORS.TEXT_MAIN
            }
          />
          <SmallText
            padding="0.5rem"
            fontSize={
              customFont && customFont.fontSM
                ? customFont.fontSM
                : THEME.FONTSIZE.SMALL
            }
            style={{
              fontFamily:
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR,
            }}
            color={
              customColor && customColor.text && customColor.text.app
                ? customColor.text.app
                : THEME.COLORS.TEXT_MAIN
            }>
            NOVO CONTEÚDO
          </SmallText>
        </ContentIconAdmin>
      </ViewButton>
      <FlatList
        data={videos}
        extraData={selectedId}
        keyExtractor={(item) => item.docId}
        renderItem={({ item, index }) => (
          <Provider>
            <TouchableOpacity
              style={{ marginVertical: '0.8rem' }}
              key={item.key}
              onPress={() => onVideoListClick(item)}
            >
              <ContainerPlaylist>
                <Avatar
                  resizeMode="cover"
                  source={{ uri: item.backgroundImage?.url || item.image }}
                >
                  <View style={{ flexDirection: 'row', flex: 1 }}>
                    <ViewCommentNotification />
                    <ContentImage
                      onPress={() => onEditVideoBackgroundClick(item)}
                    >
                      <MaterialIcons
                        name="add-a-photo"
                        size={addAPhotoSize}
                        color={THEME.COLORS.TEXT_MAIN}
                      />
                    </ContentImage>
                    {item.hasNewComment == true && user?.isAdmin && (
                      <ViewCommentNotification>
                        <MaterialCommunityIcons
                          name="comment-eye"
                          size={18}
                          color={
                            customColor && customColor.primary
                              ? customColor.primary
                              : THEME.COLORS.PRIMARY_900
                          }
                        />
                      </ViewCommentNotification>
                    )}
                  </View>
                </Avatar>
                <Content>
                  <StandardText
                    style={{
                      fontFamily:
                        customFont && customFont.fontFamilySubtitle
                          ? customFont.fontFamilySubtitle
                          : THEME.FONTFAMILY.MEDIUM,
                      fontSize:
                        customFont && customFont.fontMD
                          ? customFont.fontMD
                          : THEME.FONTSIZE.MEDIUM,
                    }}
                    color={
                      customColor && customColor.text && customColor.text.app
                        ? customColor.text.app
                        : THEME.COLORS.TEXT_MAIN
                    }
                    textAlign="flex-start"
                    numberOfLines={2}
                  >
                    {item.title}
                  </StandardText>
                </Content>
                <ContentIcon onPress={() => onEditVideoClick(item)}>
                  <Feather
                    name="edit-3"
                    size={24}
                    color={
                      customColor && customColor.text && customColor.text.app
                        ? customColor.text.app
                        : THEME.COLORS.TEXT_MAIN
                    }
                  />
                </ContentIcon>
                {/* Botão para copiar a página */}
                {/* {user?.isAdmin && (
                  <ContentIcon onPress={() => handleCopyPagePress(item)}>
                    <Feather
                      name="copy"
                      size={24}
                      color={customColor && customColor.text && customColor.text.app ? customColor.text.app : THEME.COLORS.TEXT_MAIN}
                    />
                  </ContentIcon>
                )} */}
                <ContentIcon
                  onPress={() => {
                    onDeleteVideoClick(item);
                  }}
                >
                  <MaterialIcons
                    name="delete-outline"
                    size={24}
                    color={
                      customColor && customColor.text && customColor.text.app
                        ? customColor.text.app
                        : THEME.COLORS.TEXT_MAIN
                    }
                  />
                </ContentIcon>
              </ContainerPlaylist>
            </TouchableOpacity>
          </Provider>
        )}
        style={{ flexGrow: 0 }}
        ListHeaderComponent={
          <ListHeader
            cardId={cardId}
            categoryId={categoryId}
            video={cardInformation}
            onEditCardInformationClick={onEditCardInformationClick}
            onEditOrderClick={onEditOrderClick}
            onDeleteCardClick={onDeleteCardClick}
            user={user}
            adminOptions={true}
          />
        }
      />

      {/* Modal para seleção do módulo de destino e categoria para copiar a página */}
      {showPageModal && (
        <Modal
          visible={showPageModal}
          animationType="slide"
          transparent={true}
          onRequestClose={() => setShowPageModal(false)}
        >
          <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' }}>
            <View style={{ width: '80%', backgroundColor: 'white', borderRadius: 10, padding: 20 }}>
              {/* Se o admin deseja mudar a categoria */}
              {showCategorySelection ? (
                <>
                  <FooterText style={{ textAlign: 'center', marginBottom: 20 }}>
                    Selecione a Categoria de Destino
                  </FooterText>
                  <FlatList
                    data={availableCategories}
                    keyExtractor={(item) => item.id}
                    renderItem={({ item }) => (
                      <TouchableOpacity
                        style={{ paddingVertical: 10, borderBottomWidth: 1, borderColor: '#ccc' }}
                        onPress={() => handleSelectCategory(item.id)}
                      >
                        <FooterText>{item.title} (ID: {item.id})</FooterText>
                      </TouchableOpacity>
                    )}
                  />
                </>
              ) : (
                <>
                  <FooterText style={{ textAlign: 'center', marginBottom: 20 }}>
                    Selecione o Módulo de Destino
                  </FooterText>
                  <FlatList
                    data={modulesForPage}
                    keyExtractor={(item) => item.id}
                    renderItem={({ item }) => (
                      <TouchableOpacity
                        style={{ paddingVertical: 10, borderBottomWidth: 1, borderColor: '#ccc' }}
                        onPress={() => handleModuleSelectForPage(item.id)}
                      >
                        <FooterText>{item.title} (ID: {item.id})</FooterText>
                      </TouchableOpacity>
                    )}
                  />
                </>
              )}
              <TouchableOpacity
                onPress={() => {
                  // Se não estiver na tela de seleção de categoria, permite mudar
                  if (!showCategorySelection) {
                    // Abrir a seleção de categoria
                    (async () => {
                      try {
                        const categoriesSnapshot = await getDocs(collection(firestore, 'categories'));
                        const categoriesList = [];
                        categoriesSnapshot.forEach((docSnap) => {
                          categoriesList.push({ id: docSnap.id, title: docSnap.data().title });
                        });
                        setAvailableCategories(categoriesList);
                        setShowCategorySelection(true);
                      } catch (error) {
                        console.error("Erro ao buscar categorias:", error);
                        Alert.alert("Erro", "Não foi possível buscar as categorias.");
                      }
                    })();
                  }
                }}
                style={{ marginTop: 20, alignSelf: 'center' }}
              >
                <FooterText color={THEME.COLORS.PRIMARY_900}>
                  {showCategorySelection ? "Voltar para Módulos" : "Mudar Categoria"}
                </FooterText>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => setShowPageModal(false)}
                style={{ marginTop: 20, alignSelf: 'center' }}
              >
                <FooterText color={THEME.COLORS.PRIMARY_900}>Cancelar</FooterText>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
      )}
    </>
  );


  return width < breakpoint ? (
    <View style={{ paddingHorizontal: "1rem" }}>{content}</View>
  ) : (
    <ContentList>{content}</ContentList>
  );

};

export default FlatListView;
